export const extractSlotNames = (text: string): string[] => {
  const regex = /\{\{([\p{L}\p{N}_]+)\}\}/gu;
  const slots: string[] = [];
  for (const match of text.matchAll(regex)) {
    if (!slots.includes(match[1])) {
      slots.push(match[1]);
    }
  }
  return slots;
};
